import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../client'
import { toCallEntries } from '../adapters/callHistory'
import type { CallEntry } from '../adapters/callHistory'
import { toDealDetail } from '../adapters/dealDetail'
import type { DealDetail } from '../adapters/dealDetail'
import type { CallHistory, DealCard } from '../types'

export const dealKey = (id: string) => ['deal', id] as const
export const callHistoryKey = (id: string) => ['deal', id, 'calls'] as const

export function useDeal(dealId: string) {
  return useQuery<DealCard, Error, DealDetail>({
    queryKey: dealKey(dealId),
    queryFn: () => apiGet<DealCard>(`/deals/${dealId}`),
    select: toDealDetail,
  })
}

/**
 * Call history is fetched when the panel opens, not with the board. The board
 * needs none of it, and on a large pipeline loading every call up front is the
 * performance hazard the audit recorded (Q1). Here it is a caching policy rather
 * than a hand-rolled "already loaded" flag.
 */
export function useCallHistory(dealId: string) {
  return useQuery<CallHistory, Error, CallEntry[]>({
    queryKey: callHistoryKey(dealId),
    queryFn: () => apiGet<CallHistory>(`/deals/${dealId}/call-history`),
    select: (payload) => toCallEntries(payload.items),
    staleTime: 60_000,
  })
}
